import React, { FC } from 'react'

import { icons } from '@/constants/icons'

import { HeaderElem, HeaderLogo } from './styles'

export const Header: FC<{
  className?: string
}> = ({ className }) => (
  <HeaderElem className={className}>
    <HeaderLogo
      src={icons.logoApp.logoWhite}
      alt="logo"
      className="header-logo"
    />
  </HeaderElem>
)
